import {Component} from '@angular/core';
import {
    BmCustomerBillingAccountDunningPaymentPlanComponent
} from "../../bm-customer-billing-account-dunning-payment-plan.component";
import {QlService} from "../../../../../../../core/shared/ql/service/ql.service";
import {QlMockService} from "../../../../../../../core/shared/ql/mock/ql-mock.service";
import * as testA from "../data/mock-customer-billing-account-A.json"

@Component({
    selector: 'bm-customer-billing-account-dunning-payment-plan-test-component',
    templateUrl: '../../bm-customer-billing-account-dunning-payment-plan.component.html',
    standalone: false,
    providers: [
        {
            provide: QlService,
            useFactory: () => new QlMockService(testA)
        }
    ]
})
export class BmCustomerBillingAccountDunningPaymentPlanTestComponent extends BmCustomerBillingAccountDunningPaymentPlanComponent {

}
